export const QUERY_KEY = 'USER';
export const QUERY_KEY_USER_DATA = 'USER_DATA';
export const QUERY_KEY_USER_PREFERENCES = 'USER_PREFERENCES';
